import { Injectable } from '@angular/core';
import { DataCollectorService } from '../data_collector_services/data_collector_service.service';

@Injectable({
  providedIn: 'root'
})
export class TokenService {

  constructor(
    private _dataCollectorService: DataCollectorService
  ) { }

  registerDeviceUrl(): string {
    return this._dataCollectorService.baseurl() + '/device/register';
  }
}
